import * as NotificationAction from '../notificationReducer';
import ReportService from '../../services/report-service';

import BdBeService from '../../services/10BdBe-service';

export const GET_LIST_ADMIN_10BDBE_NONPROFITS = 'GET_LIST_ADMIN_10BDBE_NONPROFITS';
export const GET_LIST_ADMIN_10BDBE_NONPROFITS_SUCCESS = 'GET_LIST_ADMIN_10BDBE_NONPROFITS_SUCCESS';
export const GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL = 'GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL';

export const ADMIN_10BDBE_NONPROFIT_LIST_RESET = 'ADMIN_10BDBE_NONPROFIT_LIST_RESET';
export const CHANGE_ADMIN_10BDBE_NONPROFITS = 'CHANGE_ADMIN_10BDBE_NONPROFITS'
export const CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS = 'CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS'
export const CHANGE_ADMIN_10BDBE_NONPROFITS_FAIL = 'CHANGE_ADMIN_10BDBE_NONPROFITS_FAIL'
export const LOGIN_DEAUTHORISE = 'LOGIN_DEAUTHORISE';

export const GENERATE_REPORT_LINK = 'GENERATE_REPORT_LINK';
export const GENERATE_REPORT_LINK_SUCCESS = 'GENERATE_REPORT_LINK_SUCCESS';
export const GENERATE_REPORT_LINK_FAIL = 'GENERATE_REPORT_LINK_FAIL';

export const GET_REPORT_LINK = 'GET_REPORT_LINK';
export const GET_REPORT_LINK_SUCCESS = 'GET_REPORT_LINK_SUCCESS';
export const GET_REPORT_LINK_FAIL = 'GET_REPORT_LINK_FAIL';

const initialState = {
  nonprofits10BdBe: [],
  get_status: {},
  load_status: {},
  isChangingStatus: false,
  isChangedStatus: false,
  nonprofit_count: 0
};

export const admin10BdBeListReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_LIST_ADMIN_10BDBE_NONPROFITS:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          nonprofit: 'pending',
        },
      };
    case CHANGE_ADMIN_10BDBE_NONPROFITS:
      return {
        ...state,
        isChangingStatus: true
      };
    case CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS:
      return {
        ...state,
        isChangingStatus: false,
        isChangedStatus: true
      };
    case CHANGE_ADMIN_10BDBE_NONPROFITS_FAIL:
      return {
        ...state,
        isChangingStatus: false,
        isChangedStatus: false
      };
    case GET_LIST_ADMIN_10BDBE_NONPROFITS_SUCCESS:
      return {
        ...state,
        nonprofits10BdBe: action.nonprofits,
        get_status: {
          ...state.get_status,
          nonprofit: 'success',
        },
        load_status: {
          ...state.load_status,
          nonprofit: action.load_status,
        },
        nonprofit_count: action.count
      };
    case GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          nonprofit: 'failed',
        },
      };
    case ADMIN_10BDBE_NONPROFIT_LIST_RESET:
      return {
        ...initialState,
      };
    case LOGIN_DEAUTHORISE:
      return {
        ...initialState,
      };
    case GENERATE_REPORT_LINK:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          generate_report: 'pending',
        },
      };
    case GENERATE_REPORT_LINK_SUCCESS:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          generate_report: 'success',
        },
      };
    case GENERATE_REPORT_LINK_FAIL:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          generate_report: 'failed',
        },
      };
    case GET_REPORT_LINK:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          get_report: 'pending',
        },
      };
    case GET_REPORT_LINK_SUCCESS:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          get_report: 'success',
        },
      };
    case GET_REPORT_LINK_FAIL:
      return {
        ...state,
        get_status: {
          ...state.get_status,
          get_report: 'failed',
        },
      };
    default:
      return state;
  }
};

export function getNonprofits({ ...query }) {
  return (dispatch, getState) => {
    dispatch({
      type: GET_LIST_ADMIN_10BDBE_NONPROFITS,
    });
    const { q, status } = query || {}
    const currentNonprofits = getState().adminNonprofit10BdBeList.nonprofits10BdBe
    const isQuerySearch =  (q && q.length > 0)
    const params = {
      // status: status&&status!==undefined&&status?status.toUpperCase():'DOWNLOADED',
      limit: 10,
      skip: currentNonprofits.length,
      ...(isQuerySearch && { sort: '-updated_at', q: `${q}&populate_10bd=true`}),
      ...query
    }

    return BdBeService.get({ isQuerySearch }, { params })
      .then((response) => {
        if (status === '') {
          dispatch({
            type: GET_LIST_ADMIN_10BDBE_NONPROFITS_SUCCESS,
            nonprofits: currentNonprofits && currentNonprofits.length ? [...currentNonprofits, ...response.data] : [...response.data],
            load_status: true,
            count: response?.total_nonprofits
          });
        }
         else {
          // const resultArray = response && response?.data?.map(item => {
          //   if ('data_10bd' in item && item.data_10bd && item.data_10bd.nonprofit && 'name' in item.data_10bd.nonprofit && item.data_10bd.nonprofit.name !== '') {
          //     return item.data_10bd;
          //   } else {
          //     return { ...item.data_10bd, nonprofit: { name: item.name, _id: item._id }, _id: item._id };
          //   }
          // });
          // const fres = isQuerySearch ? resultArray : response;
          const fres = response?.data;
          if (fres.length === 0) {
            dispatch({
              type: GET_LIST_ADMIN_10BDBE_NONPROFITS_SUCCESS,
              nonprofits: [],
              load_status: false,
            });
          } else {
            dispatch({
              type: GET_LIST_ADMIN_10BDBE_NONPROFITS_SUCCESS,
              nonprofits: currentNonprofits && currentNonprofits.length ? [...currentNonprofits, ...fres] : [...fres],
              load_status: true,
              count: response?.total_nonprofits
            });
          }
          return fres;
        }
        return response
      })
      .catch((error) => {
        dispatch({
          type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
        });
        dispatch(NotificationAction.addNotification(error.message));
      });
  };
}

export function approveNonprofits(id) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_ADMIN_10BDBE_NONPROFITS,
    });
    return BdBeService.set({ id })
      .then((response) => {
        if (response) {
          dispatch({
            type: CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS,
          });
          dispatch(NotificationAction.addNotification('Approved successfully', 'SUCCESS'));

        } else {
          dispatch({
            type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch({
          type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
        });
        dispatch(NotificationAction.addNotification(error.message));
      });
  };
}
export function sendEmailNonprofits(id) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_ADMIN_10BDBE_NONPROFITS,
    });
    return BdBeService.set({ id, isSendEmail: true })
      .then((response) => {
        if (response) {
          dispatch({
            type: CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS,
          });
          dispatch(NotificationAction.addNotification('Email sent successfully', 'SUCCESS'));

        } else {
          dispatch({
            type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch({
          type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
        });
        dispatch(NotificationAction.addNotification(error.message));
      });
  };
}
export function rejectNonprofits(id,rejectReason) {
  return (dispatch) => {
    dispatch({
      type: CHANGE_ADMIN_10BDBE_NONPROFITS,
    });
    return BdBeService.set({ id, isReject: true,rejectReason })
      .then((response) => {
        if (response) {
          dispatch({
            type: CHANGE_ADMIN_10BDBE_NONPROFITS_SUCCESS,
          });
          dispatch(NotificationAction.addNotification('Rejected successfully', 'SUCCESS'));

        } else {
          dispatch({
            type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
          });
        }
        return response;
      })
      .catch((error) => {
        dispatch({
          type: GET_LIST_ADMIN_10BDBE_NONPROFITS_FAIL,
        });
        dispatch(NotificationAction.addNotification(error.message));
      });
  };
}

export function generateReportLink10BdBe(nonprofitIds) {
  return (dispatch) => {
    dispatch({
      type: GENERATE_REPORT_LINK,
    });
    // parked for future
    // if (!query.createdAfter || !query.createdBefore) {  // Required Fields
    //   dispatch({
    //     type: GENERATE_REPORT_LINK_FAIL,
    //   });
    //   dispatch(NotificationAction.addNotification('Created after and Created before are required fields'));
    //   return;
    // }
    const request = {
      data: nonprofitIds,
      method: 'post'
    };
    return ReportService.get10BdBe(request)
      .then((response) => {
        dispatch({
          type: GENERATE_REPORT_LINK_SUCCESS,
        });
        dispatch(NotificationAction.addNotification('Your request has been received. Please check the Queued Downloads for the status of your request.', 'SUCCESS'));
        return response;
      })
      .catch((error) => {
        dispatch({
          type: GENERATE_REPORT_LINK_FAIL,
        });
        dispatch(NotificationAction.addNotification(error?.message?.message));
      });
  };
}


export function getReportLinks(query) {
  const { is10BdBe, nonprofitIds } = query || {}
  return (dispatch) => {
    dispatch({
      type: GET_REPORT_LINK,
    });

    return (is10BdBe ? ReportService.get10BdBe() : ReportService.get())
      .then((response) => {
        dispatch({
          type: GET_REPORT_LINK_SUCCESS,
        });
        return response;
      })
      .catch((error) => {
        dispatch({
          type: GET_REPORT_LINK_FAIL,
        });
        dispatch(NotificationAction.addNotification(error?.message?.message));
      });
  };
}

export function reset() {
  return (dispatch) => {
    dispatch({
      type: ADMIN_10BDBE_NONPROFIT_LIST_RESET,
    });
  };
}
